import { render, staticRenderFns } from "./AprobarBonoModal.vue?vue&type=template&id=1fffadde&scoped=true"
import script from "./AprobarBonoModal.vue?vue&type=script&lang=js"
export * from "./AprobarBonoModal.vue?vue&type=script&lang=js"
import style0 from "./AprobarBonoModal.vue?vue&type=style&index=0&id=1fffadde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fffadde",
  null
  
)

export default component.exports